export default [
  {
    title: "Regatta Values Framework",
    id: "regatta-values-framework.pdf"
  },
  {
    title: "Health & Safety Induction",
    id: "regatta-pioneer-point-hs-induction-manual-2022.pdf"
  },
  {
    title: "Smart Device Policy",
    id: "smart-device-policy-march-2023-v33.pdf"
  },
  {
    title: "Code of Conduct",
    id: "group-code-of-conduct-march-2024-2.pdf"
  },
  {
    title: "Drug & Alcohol Policy",
    id: "pp-drug-and-alcohol-policy-may-2024.pdf"
  },
  {
    title: "Diversity & Inclusion",
    id: "uk-all-diversity-and-inclusion.pdf"
  },
  {
    title: "Data Protection Policy",
    id: "uk-all-gdpr-non-managers.pdf"
  }
];
